import { Component } from '@angular/core';
import { AssetsPathPipe } from '@app/shared/pipes/assets-url.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'adspt-mirakl-login-button',
  templateUrl: './mirakl-login-button.component.html',
  styleUrls: ['./mirakl-login-button.component.scss'],
  imports: [NzButtonModule, AssetsPathPipe, TranslatePipe],
})
export class MiraklLoginButtonComponent {
  onLoginAuth0() {
    location.href = `${location.origin}/auth/login`;
  }
}
